/**
 * @generated SignedSource<<2db6ec0f26ec0747c8585a782bf137ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SignatureState = "REJECTED" | "SIGNED" | "WAITING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SignersDetailsModal_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly signatureEnvelope?: {
    readonly id: string;
    readonly signatures: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly member: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
        };
        readonly signedAt: {
          readonly datetime: ISO8601DateTimeString;
        } | null;
        readonly status: SignatureState;
      }>;
    };
  } | null;
  readonly " $fragmentType": "SignersDetailsModal_node";
};
export type SignersDetailsModal_node$key = {
  readonly " $data"?: SignersDetailsModal_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignersDetailsModal_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignersDetailsModal_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEnvelope",
          "kind": "LinkedField",
          "name": "signatureEnvelope",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SignaturesConnection",
              "kind": "LinkedField",
              "name": "signatures",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Signature",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DateTime",
                      "kind": "LinkedField",
                      "name": "signedAt",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "datetime",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Member",
                      "kind": "LinkedField",
                      "name": "member",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UserHandle_member"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SignableInterface",
      "abstractKey": "__isSignableInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "4450f6a233578fb310fdb91bac7f5b12";

export default node;
